var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{attrs:{"id":"app"}},[_c('router-view'),(false)?_c('global-stomp-debug-panel'):_vm._e(),_c('audio',{staticStyle:{"display":"none"},attrs:{"src":require("./assets/video/sound_Alarm.mp3"),"controls":"","id":"music"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }